/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const o=(o,e)=>setTimeout((()=>o?.current?.scrollIntoView({behavior:"smooth",block:"center"})),e);export{o as scrollInView};
//# sourceMappingURL=scrollInView.js.map
